<nav class="d-md-block sidebar toggled">
  <div class="sidebar-sticky">
    <ul class="nav flex-column">
      <li class="nav-item brand">
        <img alt src="\assets\icons\main-logo\parsagroup-logo1.png"
          class="brand-image">
          <span class="sidebar-text">Parsagroup</span>
        </li>
        @for (item of permittedSidebarItems; track $index) {
          <li class="nav-item">
            <a href="{{'#sub' + item.label.replace(' ', '_')}}"
              data-bs-toggle="collapse" aria-expanded="false"
              aria-controls="{{'#sub' + item.label}}"
              class="nav-link">
              <span class="fa-stack fa-lg"><i [ngClass]="item.icon"></i></span>
              <span class="sidebar-text">{{ item.label }}</span>
            </a>
            <ul class="collapse" id="{{'sub' + item.label.replace(' ', '_')}}">
              @for (subItem of item.subItems; track $index) {
                <li class="nav-item submenu">
                  <a class="nav-link sidebar-text sidebar-item-content"
                    [routerLink]="subItem.href"> {{ subItem.label }}
                    <span
                      class="float-end"
                      (click)="addOrRemoveShortcut(subItem.label, subItem.href)"
                      [style.display]="'inline-flex'"
                      [style.width.px]="12"
                      [style.height.px]="12"
                      [style.align-items]="'center'"
                      [style.justify-content]="'center'"
                      [style.box-sizing]="'border-box'"
                      [style.border-radius.px]="3"
                      [style.border]="'1.5px solid #A0A9B8'"
                      [style.background-color]="isChecked(subItem.label) ? '#525866' : 'transparent'"
                      [style.cursor]="'pointer'"
                      [style.transition]="'all 0.2s ease'">

                      @if (isChecked(subItem.label)) {
                        <i
                          class="fa fa-check"
                          [style.color]="'#ffffff'"
                          [style.font-size.px]="6"
                          [style.font-weight]="'bold'">
                        </i>
                      }
                    </span>
                  </a>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
    <div class="version"><span>Version {{version}}</span></div>
  </nav>
